export default __webpack_public_path__ + "static/media/warning--snowmobiles--g2.0f139051.png";